<template>
    <!--画图-->
    <div
            @click="clickFn()"
            :id="`comp${  idk  }`"
            class="p-relative p-line-height1"
            :style="`width:${ width }px; height:${ height }px; font-size:${ fontSize }px; color:${ color };  background:${ componentColor };  padding-top:${  padding[0]  }; padding-right:${  padding[1]  }; padding-bottom:${  padding[2]  }; padding-left:${  padding[3]  };`"
    >

        <!--虚线-->
        <ul  id="yZhou2"  class="p-relative">
            <li  v-if="key!==0"  v-for="(val,key) in yAxis"  class="p-width100"  style="position:absolute; left:0px; border-bottom:1px dashed #cccccc;"  :style="`top:calc(${ height }px - (${ height }px / ${ yAxis.length-1 })*${ key });`">
            </li>
        </ul>


        <canvas  id="canvas"  :width="width"  :height="height"   class="p-relative" style="border-bottom:1px solid black;"  :style="`background:${  canvasColor  };`"></canvas>


        <div  id="parent"  style="position:absolute; left:0px; top:0px;"  :style="`width:${ width }px; height:${ height }px; left:${  padding[3]  }; top:${  padding[0]  };`">
            
            <!--x轴标量-->
            <div  v-if="type=='brokenLine3'"  id="xZhou"  class="p-width100"  style="position:absolute; left:0px;"  :style="`top:${ height+textSpace }px;`">
                <span  v-if="xAxisStrs.length==4" class="p-float-left p-relative p-center" >
                    <span class="p-float-left p-relative p-left"  style="text-align: left;" :style="`width:calc(${ width }px / ${ xAxisStrs.length });`" >{{xAxisStrs[0]}}</span>
                    <span class="p-float-left p-relative p-center"  :style="`width:calc(${ width }px / ${ xAxisStrs.length });`" >{{xAxisStrs[1]}}</span>
                    <span class="p-float-left p-relative p-center"  :style="`width:calc(${ width }px / ${ xAxisStrs.length });`" >{{xAxisStrs[2]}}</span>
                    <span class="p-float-left p-relative p-right" style="text-align: right;" :style="`width:calc(${ width }px / ${ xAxisStrs.length });`" >{{xAxisStrs[3]}}</span>
                    </span>
                <span  v-else-if="xAxisStrs.length==3" class="p-float-left p-relative p-center" >
                    <span class="p-float-left p-relative p-left"  style="text-align: left;" :style="`width:calc(${ width }px / ${ xAxisStrs.length });`" >{{xAxisStrs[0]}}</span>
                    <span class="p-float-left p-relative p-center"  :style="`width:calc(${ width }px / ${ xAxisStrs.length });`" >{{xAxisStrs[1]}}</span>
                    <span class="p-float-left p-relative p-right" style="text-align: right;" :style="`width:calc(${ width }px / ${ xAxisStrs.length });`" >{{xAxisStrs[2]}}</span>
                    </span>
                <span  v-else-if="xAxisStrs.length==2" class="p-float-left p-relative p-space-between" >
                    <span class="p-float-left p-relative p-left"   style="text-align: left;" :style="`width:calc(${ width }px / ${ xAxisStrs.length });`" >{{xAxisStrs[0]}}</span>
                    <span class="p-float-left p-relative p-center" style="text-align: right;"  :style="`width:calc(${ width }px / ${ xAxisStrs.length });`" >{{xAxisStrs[1]}}</span>
                    </span>
                <ul  v-else  id="xZhou"  class="p-width100"  style="position:absolute; left:0px;"  :style="`top:${ height+textSpace }px;`">
                    <li  v-for="val in xAxisStrs"  class="p-float-left p-relative p-center"  :style="`width:calc(${ width }px / ${ xAxisStrs.length });`"  >
                        <span >{{val}}</span>
                    </li>
                </ul>
            </div>
            <ul  v-else-if="xAxisStrs&&xAxisStrs.length>0"  id="xZhou"  class="p-width100"  style="position:absolute; left:0px;"  :style="`top:${ height+textSpace }px;`">
                <li  v-for="val in xAxisStrs"  class="p-float-left p-relative p-center"  :style="`width:calc(${ width }px / ${ xAxisStrs.length });`"  >
                    <span >{{val}}</span>
                </li>
            </ul>
            <!--x轴标量-->
            <ul  v-else-if="xAxisType=='test'"  id="xZhou"  class="p-width100"  style="position:absolute; left:0px;"  :style="`top:${ height+textSpace }px;`">
                <li  v-for="val in xAxis"  class="p-float-left p-relative p-center"  :style="`width:calc(${ width }px / ${ xAxis });`"  >
                    <span  v-if="xAxis==7">{{getWeekInLanguage(val,this)}}</span>
                    <span  v-else-if="xAxis>12 && val%2!=0">&nbsp;</span>
                    <span  v-else>{{val}}</span>

                    <div  v-if="xAxis>12 && val%2!=0"  :style="`top:${  -1*textSpace - 10  }px;`"  style="position:absolute; left:0px; width:1px; height:10px; background:black;"></div>
                    <div  v-else  :style="`top:${  -1*textSpace - 4  }px;`"  style="position:absolute; left:0px; width:1px; height:4px; background:black;"></div>
                </li>
            </ul>

            <ul  v-else  id="xZhou"  class="p-width100"  style="position:absolute; left:0px;"  :style="`top:${ height+textSpace }px;`">
                <li  v-for="val in xAxis"  class="p-float-left p-relative p-center"  :style="`width:calc(${ width }px / ${ xAxis });`"  >
                    <!--日-->
                    <span  v-if="xAxis==24"  class="p-box-center p-inline-block">
                        <div  style="min-width:6rem;">
                            <span  v-if="(val-3)%6!=0">&nbsp;</span>
                            <span  v-else>{{  val  }} {{  ":00"  }}</span>
                        </div>
                    </span>
                    <!--周-->
                    <span  v-else-if="xAxis==7">{{getWeekInLanguage(val,this)}}</span>
                    <!--月-->
                    <span  v-else-if="xAxis>12"  class="p-box-center p-inline-block">
                        <div  style="min-width:6rem;">
                            <span  v-if="(val-3)%6!=0">&nbsp;</span>
                            <span  v-else>{{  time(newTime).format('M')  }}  /  {{  val  }}</span>
                        </div>
                    </span>
                    <!--年-->
                    <span  v-else>{{val}}</span>

                    <!--<div  v-if="xAxis>12 && val%2!=0"  :style="`top:${  -1*textSpace - 10  }px;`"  style="position:absolute; left:0px; width:1px; height:10px; background:black;"></div>
                    <div  v-else  :style="`top:${  -1*textSpace - 4  }px;`"  style="position:absolute; left:0px; width:1px; height:4px; background:black;"></div>-->
                </li>
            </ul>



        <!--x轴标量-->
            <ul  v-if="yAxisStrs&&yAxisStrs.length>0"  id="yZhou">
                <li  v-for="(val,key) in yAxisStrs" style="position:absolute;"  :style="`left:${ width+textSpace }px; top:calc(${ height }px - (${ height }px / ${ yAxisStrs.length })*${ key } - ${  fontSize/3  }px);`">
                    <span  >{{val}}</span>
                </li>
            </ul>
            <!--y轴标量（包括虚线）-->
            <ul v-else id="yZhou">
                <li  v-for="(val,key) in yAxis"  style="position:absolute;"  :style="`left:${ width+textSpace }px; top:calc(${ height }px - (${ height }px / ${ yAxis.length-1 })*${ key } - ${  fontSize/3  }px);`">
                    {{  val*scale | fmoney  }}
                </li>
            </ul>


            <!--滚动轴-->
            <div  v-show="type!=='waveLineNoDrag'"
                    id="drag"
                    class="p-box-center p-pointer p-user-select"
                    style="position:absolute; top:0px; left:0px;"
                    :style="`width:${  axiosWidth  }px; height:${  height  }px; background:${  axiosColor  };`"
            >
                <div  :style="`height:100%;`">
                    <div
                            v-show="returnData.y>0&&type!=='brokenLine3'"
                            class="p-relative p-inline-block p-white-text p-center"
                            style="line-height:2.2; opacity:0.8"
                            :style="`border-radius:${  fontSize*2.2  }px; font-size:${  fontSize*1.2  }px; background:${  btnColor  };`"
                    >
                        <div  class="p-inline-block"  style=" height:1rem; z-index:2;"    :style="`min-width:2rem; width:auto; white-space:nowrap; padding:0px 0.7rem;`">
                            <slot name="default"></slot>
                        </div>


                        <!--尖角-->
                        <div
                                style="position:absolute; left:50%; transform:translateX(-50%) rotate(45deg) skew(20deg,20deg); background:inherit;"
                                :style="`bottom:${  fontSize*(-0.5)  }px; width:${  fontSize  }px; height:${  fontSize  }px;`"
                        >
                        </div>
                    </div>

                    <!--透明轴-->
                    <div
                            style="position:absolute; top:0px;"
                            :style="`left:calc((${  btnWidth  }px - ${ axiosWidth }px) / 2 * (-1)); width:${  btnWidth  }px; height:${  height  }px`">
                    </div>

                    <!--圆-->
                    <div
                            v-show="circleShow"
                            id="circle"
                            class="p-inline-block p-radius50"
                            style="position:absolute; left:50%; transform:translate(-50%);"
                            :style="`width:${  fontSize*0.7  }px; height:${  fontSize*0.7  }px; top:${  (height - top) + lineWidth/2 - (lineWidth + 8 + lineWidth/2)  }px; background:${  btnColor  }; box-shadow:0px 0px 10px ${  btnColor  }; border:${  lineWidth  }px solid ${  'white'  };`"
                    >
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
    import mixins2 from '@/utils/mixins2.js'
    import {
        getWeekInLanguage 
    } from "@/utils/methods.js"

    export default {
        name: "brokenLine",
        mixins:[mixins2],
        data(){
            return {
                circleShow:false,   // div圆是否显示
                top:0,  // 圆的定位置
            }
        },
        props:{
            type:{  type:String, required:false, default:'brokenLine'  },   // 图案类型  brokenLine、waveLine

            // 渐变颜色设置
            middleGradientColor:{  type:String, required:false, default:"rgba(247,140,72,0.7)"  },  // rgba(247,140,72,0.7)

            axisOffset:{  type:Number, required:false, default:-1  },        // 滚动轴偏移量，使其居中

        },
        methods:{
            getWeekInLanguage,
            scrollSuccess(docu,context){
                let left = Number.parseFloat(docu.querySelector("#drag").style.left);
                this.returnData = {  x:left, y:" ", y2:" " };
                if(  this.type==='waveLineNoDrag'){
                    return;
                }
                if(  this.dots.length > 0  ){
                    let left = Number.parseFloat(docu.querySelector("#drag").style.left);
                    let min = this.dots[0]["x"];    // 最小值
                    let index = 0;   // 最小值的索引
                    this.circleShow = false;

                    if(  this.type==='brokenLine3'){
                        let item = this.dots[0];
                         // 在dots中，循环获取最接近的点集
                        for(  let i=0; i<this.dots.length; i++  ){
                            item = this.dots[i];
                            // console.log('sendData item',item,'   i=',i,'   left=',left,'   x1=',item["x1"],'   x=',item["x"] )
                            // 循环点到滑动轴的x距离<minAxisSpace*0.5     循环点到滑动轴的x距离 < 之前保存的最小x距离
                            if(  left<=item["x1"]&&left>item["x"]  ){
                                break;
                            }
                        }
                        this.returnData = {  x:item.x, y:item.y*this.scale, y2:item.y2*this.scale,data:item.data  };
                    }else{
                        // 在dots中，循环获取最接近的点集
                        for(  let i=1; i<this.dots.length; i++  ){
                            let item = this.dots[i];

                            // 循环点到滑动轴的x距离<minAxisSpace*0.5     循环点到滑动轴的x距离 < 之前保存的最小x距离
                            if(  Math.abs(item["x"]-left) < this.minAxisSpace*0.5  &&  Math.abs(item["x"]-left) < Math.abs(min-left)  ){
                                min = item["x"];
                                index = i;
                            }
                        }

                        // 保存的到滑动轴的x距离<minAxisSpace*0.5时，才会进行二次滚动
                        if(  Math.abs(min-left) < this.minAxisSpace*0.5  ){
                            // console.log("存在重合点");
                            left = min;
                            // 滚动轴选中点集
                            let item = this.dots.find(function(currentValue,index,arr){
                                return currentValue.x === left;
                            });
                            // console.log('111item=',item,',this.scale=',this.scale)
                            docu.querySelector("#drag").style.left = (left + this.axisOffset) + "px";
                            if(  item  ){
                                if(  this.type==='brokenLine' || this.type==='waveLine'  ){
                                    // 避免切换曲线、折线时，显示异常
                                    let timer=setTimeout(()=>{
                                        // docu.querySelector("#circle").style.top = (this.height - item["y"]) + "px";   // 不需要重新渲染canvas
                                        this.top = item.y;
                                        this.circleShow = true;

                                        clearTimeout(timer);
                                    },100);
                                }
                                console.log('111item=',item,',this.scale=',this.scale)
                                this.returnData = {  x:item.x, y:item.y*this.scale, y2:item.y2*this.scale,data:item.data   };
                               
                            }
                        }
                    }
                }
                // 发送数据到父级,避免sendData比请求接口的数据更快，显示上一次的数据-------------------------------------------------------
				/* let timer = setTimeout(()=>{
					this.$emit("sendData",this.returnData);
										
					clearTimeout(timer);
				},500); */
                // console.log('sendData this.returnData=',this.returnData)
				this.$emit("sendData",this.returnData);
                
            },
            // 整体画完
            canvasAll(context){
                context.clearRect(0,0,this.width,this.height);

                // 避免切换曲线、折线时，显示异常
                let timer=setTimeout(()=>{
                    if(  this.type=='brokenLine'  ){
                        if(  this.dots.length>1  ){
                            this.brokenLine(context,this.colorArr);
                        }
                        else if(  this.dots.length>0  ){
                            let item = this.dots[0];
                            this.line(context,{  x:item["x"], y:0  },{  x:item["x"], y:item["y"]  },[this.colorArr[1],this.colorArr[2]],this.lineWidth*3);
                        }
                    }
                    else if(  this.type=='waveLine' ||this.type=='waveLineNoDrag' ){
                        if(  this.dots.length>1  ){
                            this.waveLine(context,this.colorArr);
                        }
                        else if(  this.dots.length>0  ){
                            let item = this.dots[0];
                            this.line(context,{  x:item["x"], y:0  },{  x:item["x"], y:item["y"]  },[this.colorArr[1],this.colorArr[2]],this.lineWidth*3);
                        }

                    }
                     else if(  this.type=='brokenLine3'){
                        if(  this.dots.length>1  ){
                            this.brokenLine3(context,this.colorArr);
                        }
                        else if(  this.dots.length>0  ){
                            let item = this.dots[0];
                            this.line(context,{  x:item["x"], y:0  },{  x:item["x"], y:item["y"]  },[this.colorArr[1],this.colorArr[2]],this.lineWidth*3);
                        }

                    }

                    clearTimeout(timer);
                },100);


            },

        },
    }
</script>